"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
function Usage(_a) {
    var width = _a.width, height = _a.height, className = _a.className;
    return (React.createElement("svg", { height: "".concat(height), viewBox: "0 0 52 46", className: "".concat(className), width: "".concat(width) },
        React.createElement("path", { d: "M-1.50866e-06 3.52742L-1.54123e-07 34.5157C-6.87367e-08 36.4691 1.58016 38.0416 3.53204 38.0416L48.4695 38.0416C50.4152 38.0416 52 36.4691 52 34.5157L52 3.52741C52 1.58013 50.4168 -3.27214e-05 48.4695 -3.26362e-05L3.53203 -3.0672e-05C1.58016 -0.00308995 -1.59385e-06 1.5786 -1.50866e-06 3.52742ZM50.6768 19.02C50.6768 20.1795 49.7391 21.1172 48.5812 21.1172C47.4217 21.1172 46.4824 20.1795 46.4824 19.02C46.4824 17.8636 47.4217 16.9228 48.5812 16.9228C49.7391 16.9228 50.6768 17.8636 50.6768 19.02ZM45.6453 3.56872L45.6453 34.4713L3.24334 34.4713L3.24334 3.56872L45.6453 3.56872Z", fill: "white" }),
        React.createElement("path", { d: "M35.351 22.9691H35.175C34.151 22.9691 33.3171 23.8011 33.3171 24.8231V26.4811H33.0891V24.8231C33.0891 23.8001 32.253 22.9691 31.233 22.9691H31.051C30.03 22.9691 29.197 23.8011 29.197 24.8231V26.4811H28.967V24.8231C28.967 23.8001 28.133 22.9691 27.113 22.9691H26.929C25.909 22.9691 25.075 23.8011 25.075 24.8231V26.4811H24.9541V15.8871C24.9541 14.8581 24.121 14.0211 23.088 14.0211L22.907 14.0201C21.88 14.0201 21.0441 14.8571 21.0441 15.8871V32.0961C20.5461 31.5341 20.1081 30.9611 19.7071 30.4441C18.8151 29.2901 18.114 28.3761 17.322 28.1941C16.443 27.9851 15.631 28.2781 15.24 28.9121C14.873 29.5151 14.929 30.3451 15.393 31.2451C16.409 33.1881 21.29 41.7241 21.293 41.7241C21.679 42.6581 23.3821 45.7101 29.1161 45.7101V45.5061L29.1221 45.7101C33.2921 45.7101 35.267 43.7421 36.19 42.0921C37.186 40.3101 37.202 38.5541 37.202 38.4781V24.8231C37.206 23.7991 36.369 22.9691 35.351 22.9691Z", fill: "white" })));
}
Usage.propTypes = {
    width: prop_types_1.default.number,
    height: prop_types_1.default.number,
    className: prop_types_1.default.string,
};
Usage.defaultProps = {
    width: 64,
    height: 64,
};
exports.default = Usage;
